import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import messages from '../CompanyDetails.messages';

export const TradingNameQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            className="fs-exclude"
            label={<FormattedMessage {...messages.tradingName} />}
            name="tradingName"
            id="tradingName"
            onChangeHandler={onChange}
        />
    );
};
